import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { StockAction } from './stock.actions';
import { StockListPagination } from '../models/stock-list.model';
import { AdjustTransaction, StockInfoBarcode, StockMovementList, StockView } from '../models/stock-view.model';

export const stockKey = 'stock';

export interface StockState {
  stockListPagination: StockListPagination;
  negativeStock: number;
  stockView: StockView;
  stockMovementList: any;
  stockBarcode: StockInfoBarcode[];
  stockMovementListPagination: Pagination<StockMovementList>;
  adjustTransaction: AdjustTransaction[];
}

export const initialState: StockState = {
  stockListPagination: null,
  negativeStock: 0,
  stockView: null,
  stockMovementList: null,
  stockBarcode: null,
  stockMovementListPagination: null,
  adjustTransaction: null
};

export const stockReducer = createReducer<StockState>(
  initialState,
  on(StockAction.stockListResponse, (state, response) => {
    return { ...state, stockListPagination: response.response };
  }),
  on(StockAction.stockSummaryResponse, (state, response) => {
    return { ...state, stockView: response.response };
  }),
  on(StockAction.stockSummaryResponse, (state, response) => {
    return { ...state, stockView: response.response };
  }),
  on(StockAction.stockMovementListResponse, (state, response) => {
    return { ...state, stockMovementListPagination: response.response };
  }),
  on(StockAction.stockBarcodeListResponse, (state, response) => {
    return { ...state, stockBarcode: response.response };
  }),
  on(StockAction.stockListNativeCountResponse, (state, response) => {
    return { ...state, negativeStock: response.response.negativeStockQuantity };
  }),
  on(StockAction.adjustTransactionResponse, (state, response) => {
    return { ...state, adjustTransaction: response.response };
  })
);
